import React, { Component } from "react";

import { SampleWorkflowContextProvider } from "./context/context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class SampleWorkflowsPage extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <SampleWorkflowContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </SampleWorkflowContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default SampleWorkflowsPage;
